import * as React from 'react';
import { connect, Dispatch } from 'react-redux';

import * as Actions from '../actions';
import { AnalyseState } from '../interfaces/state';
import { OverreadStatusEnum } from '../../../misc/api/apiTypes';
import { AuditModal } from "../../../auditmodal/components/AuditModal";
import once from 'lodash-es/once';
import { useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';
import { useHistory } from 'react-router-dom';

interface AcceptabilityDashboardProps {
    isVisible: boolean;
    primaryAnalysisSetId: string;
    acceptabilityModalVisiblility: boolean;
    selectedAcceptability: OverreadStatusEnum;
    isSubmitting: boolean;

    dispatch?: Dispatch<AnalyseState>;
}

export const AcceptabilityDashboard = (props: AcceptabilityDashboardProps) => {
    const legacyClient = useWebPortalLegacyClient();
    const history = useHistory();

    const onSubmit = once((audit) => {
        props.dispatch(Actions.AcceptabilitySetAsyncAction.create(legacyClient, history, props.primaryAnalysisSetId, props.selectedAcceptability, audit.Annotation));
    })

    if (props.isVisible) {
        return (
            <>
                <div className="panel panel-default">
                    <div className="panel-body">
                        <button className="btn btn-success" disabled={props.isSubmitting} onClick={() => { props.dispatch(Actions.ShowAcceptabilityAuditModalAction.create(OverreadStatusEnum.Accepted)) }}>
                            <i className="fa fa-check" aria-hidden="true"></i>  Accept
                        </button>&nbsp;
                        <button className="btn btn-warning" disabled={props.isSubmitting} onClick={() => props.dispatch(Actions.AcceptabilitySetAsyncAction.create(legacyClient, history, props.primaryAnalysisSetId, OverreadStatusEnum.Pending))}>
                            <i className="fa fa-circle-o" aria-hidden="true"></i> Pending
                        </button>&nbsp;
                        <button className="btn btn-danger" disabled={props.isSubmitting} onClick={() => { props.dispatch(Actions.ShowAcceptabilityAuditModalAction.create(OverreadStatusEnum.Rejected)) }}>
                            <i className="fa fa-times" aria-hidden="true"></i> Reject
                        </button>
                    </div>
                </div>
                {props.acceptabilityModalVisiblility ?
                    <AuditModal header="Analysis Approval"
                        isSubmitting={props.isSubmitting}
                        onSubmit={onSubmit}
                        onClose={() => props.dispatch(Actions.CloseAcceptabilityAuditModalAction.create())} />
                    : null}
            </>
        );
    } else {
        return null;
    }
}

function mapStateToProps(state: AnalyseState): AcceptabilityDashboardProps {
    return {
        isVisible: !state.core.isViewOnly,
        primaryAnalysisSetId: state.analysisSet.primaryAnalystSetId,
        acceptabilityModalVisiblility: state.core.isAcceptabilityAuditModalVisible,
        selectedAcceptability: state.core.acceptabilityStatus,
        isSubmitting: state.core.isSubmitting,
    } as AcceptabilityDashboardProps;
}

export default connect<AcceptabilityDashboardProps, any, void>(mapStateToProps)(AcceptabilityDashboard);
